export const API_BASE_PATH = `/_napi/da-sisu/api`;
export const reduxKey = '@@social_login';
